import { useAuthStore } from '@caradasstore/AuthStore'
import { useCenterStore } from '@caradasstore/CenterStore'
import { useOrganisationStore } from '@caradasstore/OrganisationStore'
import { useUserStore } from '@caradasstore/UserStore'
import { useAvailabilityStore } from '@caradasstore/AvailabilityStore'
import useAdasIntelligenceStore from '@caradasstore/AdasIntelligenceStore'
import useBillingStore from '@caradasstore/BillingStore'
import { useEntitlementStore } from '@caradasstore/EntitlementStore'
import { purge } from './persist'
import { clearCachedCalibrationCenters } from './calibrationCenterCache'
import { resetCenterListBootstrap } from './centerListBootstrap'
import { resetCenterDetailFetchGuard } from './centerDetailFetchGuard'

/**
 * Ends the session and leaves nothing of the account behind, then opens the login page.
 *
 * The one sign-out routine (CAR-4086): the phone menu, the desktop menu and the session-expired
 * path in AuthFailureInterceptor all call it. They used to keep their own copies, which drifted -
 * the phone copy called a setLoggedIn that AuthStore never had, so phone Sign Out threw and did
 * nothing.
 *
 * Sign-out is an SPA navigation (no reload), so module-level guards must be cleared here too.
 */
export const signOut = (history) => {
  useAuthStore.getState().logout()
  // Every per-account store, so the next user lands on a clean slate rather than seeing the last
  // account's centers, assignee list, organisation, availability, AI filters, billing or plan.
  useCenterStore.getState().reset?.()
  useUserStore.getState().reset?.()
  useOrganisationStore.getState().reset?.()
  useAvailabilityStore.getState().reset?.()
  useAdasIntelligenceStore.getState().reset?.()
  useBillingStore.getState().reset?.()
  // Entitlements are per user (plan narrowed by role): the next account must not inherit them.
  useEntitlementStore.getState().reset?.()
  purge()
  clearCachedCalibrationCenters()
  // Module-level guards: without these the next sign-in in this tab skips the full center-list
  // fetch and the re-read of the center's details.
  resetCenterListBootstrap()
  resetCenterDetailFetchGuard()
  // AuthStore persists under its own key, which purge() (zustand-persist) does not touch.
  try {
    localStorage.removeItem('auth-state')
  } catch {
    /* ignore */
  }
  history?.push('/authenticate')
}
